import * as React from "react"
import { Link } from "react-router-dom"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { isResendActivationState, LoginState, ResendActivationState } from "../state"
import { notifications } from '../notifications';
import { Api } from '../api_to_state';
import { MinimalLoginWidgetData, update_state_with_route } from "../login";
import { getClassName } from "../../utils/utils.mod";
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";


function handleSubmit<a, extra_user_info>(e:React.FormEvent<HTMLFormElement>, setState:(_: Action<LoginState<a, extra_user_info>>) => void, api:Api<extra_user_info>) {
  e.preventDefault();
  setState(s => isResendActivationState(s) 
    ? (api && api.isValidEmail && api.isValidEmail(s.login_data.email!) 
      ? ({ status:"resend activation - resending", login_data: s.login_data }) 
      : { ...s, login_data: { ...s.login_data, email: s.login_data.email == undefined ? "" : s.login_data.email }})
    : s);
}

export function resend_activation_form<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0:ResendActivationState, readonly:boolean, rootpath:string, api?:Api<extra_user_info>): Widget<Action<LoginState<a, extra_user_info>>> => {
    let email_error = (s0.login_data.email != undefined && !(api && api.isValidEmail && api.isValidEmail(s0.login_data.email)));
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-resend-activation-form"> 
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "mb-4")}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>Lost activation e-mail</h1>
                <p className={getClassName(options, "intro_classname", "lead")}></p>
              </header>
    
              <form onSubmit={(e) => handleSubmit(e, setState, api)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  {notifications(s0, { style: LoginFlowClasses }).run(() => s => s)}

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="email"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      E-mail address
                    </label>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      aria-invalid={email_error}
                      aria-describedby={email_error ? "a11y-email-error": null}
                      className={getClassName(options, "form_input_classname", `form-control ${email_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.email || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isResendActivationState(s) ? ({
                        ...s,
                        status:"resend activation",
                        login_data: {
                          ...s.login_data,
                          email:event.currentTarget.value }
                        }) : s)
                      }
                    />
                    {email_error && (
                      <p id="a11y-email-error" className={getClassName(options, "form_error_classname", "invalid-feedback d-block")}>
                        Invalid e-mail address
                      </p>
                    )}
                  </div>
                  
                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      disabled={readonly}
                    >
                      Request new activation
                    </button>
    
                    {data.without_browserRouter
                      ? <button
                          type="button"
                          className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                          onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                        >
                          Sign in
                        </button>
                      : <Link
                          to={rootpath}
                          className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                        >
                          Sign in
                        </Link>
                    }
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}

export function resend_activation_success<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0:ResendActivationState, rootpath:string): Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")}>
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "mb-4")}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>Lost activation e-mail</h1>
                <p className={getClassName(options, "intro_classname", "lead")}>
                  {`An activation e-mail has been sent to ${s0.login_data.email}. You will receive a link to activate your account shortly, provided that it exists in the system and the account is not active.`}
                </p>
                <p className={getClassName(options, "intro_classname", "")}>If you need assistance, please contact <a href="mailto:info@hoppinger.com">info@hoppinger.com</a>.</p>
              </header>
              
              <footer className={getClassName(options, "form_actions_classname", "")}>
                {data.without_browserRouter
                  ? <button
                      type="button"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                    >
                      Sign in
                    </button>
                  : <Link
                      to={rootpath}
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                    >
                      Sign in
                    </Link>
                }
              </footer>
            </div>
          </section>
        )
      }
    })
  }
}